import React, { useState, useEffect, useCallback, useRef } from 'react';

// Options should be an arrao with objects in this format: { title: String, slug: String }
function CustomSelect({ placeholderText, options = [], selectedOptionSlug = null, setSelectedOptionSlug = null, btnClasses = '', optionBtnClasses = 'btn--beige', compact = false }) {
    const wrapperEl = useRef(null);
    const [showSelect, setShowSelect] = useState(false);

    const handleOutsideClick = useCallback(e => {
        if (wrapperEl.current && !wrapperEl.current.contains(e.target)) {
            setShowSelect(false);
        }
    }, []);

    const handleKeyUp = useCallback(e => {
        if (e.key.toLowerCase() === 'escape') setShowSelect(false);
    }, []);

    useEffect(() => {
        document.addEventListener('mouseup', handleOutsideClick);
        window.addEventListener('keyup', handleKeyUp);

        return () => {
            document.removeEventListener('mouseup', handleOutsideClick);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleOutsideClick, handleKeyUp]);

    const selectedOption = selectedOptionSlug === null ? null : options.find(option => option.slug === selectedOptionSlug) || null;

    function onOptionClick(slug) {
        if (typeof setSelectedOptionSlug === 'function') setSelectedOptionSlug(slug);
        setShowSelect(false);
    }

    return (<>
        { !! options.length > 0 &&
            <div ref={wrapperEl} className={'custom-select' + (showSelect ? ' open' : '') + (compact ? ' custom-select--compact' : '')}>
                { !! options.length > 0 && <button className={'custom-select__btn btn btn--arrow-inline btn--arrow-inline-down ' + (selectedOptionSlug === null || !selectedOption ? ' placeholder' : '') + btnClasses} onClick={() => setShowSelect(!showSelect)}>{selectedOption ? selectedOption.title : placeholderText}</button>}

                <ul className="custom-select__options">
                    { options.map((option, i) => (<li key={'' + Math.random() + Math.random()}><button className={'custom-select__option btn ' + optionBtnClasses} onClick={() => onOptionClick(option.slug)}>{option.title}</button></li>)) }
                </ul>
            </div>
        }
    </>);
}

export default CustomSelect;